import React from "react";
//import { useContext } from 'react';
//import { createContext, useState } from 'react';
//import ReactDom from "react-dom";
import {createRoot} from 'react-dom/client';

import App from "./components/App";
import { LayoutFlagProvider } from "./components/providers/LayoutFlagProvider";

//React v18+
const root = createRoot(document.getElementById('search-cid'));
root.render(
    <LayoutFlagProvider>
        <App />
    </LayoutFlagProvider>
);